import { render, staticRenderFns } from "./ModalSuspectBox.vue?vue&type=template&id=dd1fa04e&"
import script from "./ModalSuspectBox.vue?vue&type=script&lang=js&"
export * from "./ModalSuspectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports